import {
  Consumption,
  Costs,
  HitrateDetails,
  OtherPartsReferences,
  ProductHierarchy,
  SourcingDetails,
  Stock,
  UsedInEngineType,
  Successor,
  ResponsibleReferences,
} from "../constants/columns/MainData";
import React, { FunctionComponent } from "react";
import { getFormValues } from "redux-form";

import { AccountInfo } from "@azure/msal-browser";
import { MainDataColumnComponent } from "./MainDataColumnComponent";
import { ProductDashboardFormName } from "../constants/formNames";
import { SeverityGroup } from "../types/model";
import { RootState } from "../types/state";
import { connect } from "react-redux";

interface MainDataProps {
  onClick: (index: number) => void;
  profile?: AccountInfo | undefined;
  severityGroups?: SeverityGroup[];
  onFieldChange: (form: string, field: string, value: string) => any;
}

const mapStateToProps = (state: RootState) => ({
  formValues: getFormValues(ProductDashboardFormName)(state) as any,
  product: state.product,
  profile: state.profile,
  severityGroups: state.severityGroups?.severityGroups,
});

type Props = ReturnType<typeof mapStateToProps> & MainDataProps;

const MainDataComponent: FunctionComponent<Props> = ({
  product,
  formValues,
  onClick,
  profile,
  severityGroups,
  onFieldChange,
}) => {
  var severityGroupsFiltered = [] as { label: string; value: String }[];
  if (severityGroups !== undefined && severityGroups !== null) {
    severityGroupsFiltered = severityGroups.map((sg) => {
      return {
        label: sg.severityGroup1 + ": " + sg.severityGroupDescription,
        value: sg.severityGroup1,
      };
    });
  }

  const onSeverityGroupChanged = (val) => {
    var severityGroup = severityGroups?.find((x) => x.severityGroup1 === val);
    if (severityGroup != null)
      onFieldChange(
        "",
        "mainData.severityGroupDescription",
        severityGroup.severityGroupDescription
      );
  };

  var mainData = formValues?.mainData;

  return (
    <div className="columns">
      <div className="column is-5">
        <div className="columns">
          <MainDataColumnComponent
            content={Stock(profile)}
            backgroundColorHeader={"#000000"}
            headerTitle="STOCK"
          />
          <MainDataColumnComponent
            content={Consumption(profile)}
            backgroundColorHeader={"#3AC6FA"}
            headerTitle="CONSUMPTION - INCL.PREDCESSORS"
          />
        </div>
        <div className="columns">
          <MainDataColumnComponent
            content={Costs(profile)}
            backgroundColorHeader={"#DB0800"}
            headerTitle="COSTS / PRICING"
          />
        </div>
        <div className="columns">
          <MainDataColumnComponent
            content={HitrateDetails(profile)}
            backgroundColorHeader={"#8E00C3"}
            headerTitle="HITRATE DETAILS (LAST 365 DAYS)"
          />
        </div>
      </div>
      <div className="column is-4">
        <div className="columns">
          <MainDataColumnComponent
            content={ProductHierarchy(profile)}
            backgroundColorHeader={"#484848"}
            headerTitle="PRODUCT HIERARCHY / MATERIAL GROUP"
          />
        </div>
        <div className="columns">
          <MainDataColumnComponent
            content={SourcingDetails(
              mainData
            )}
            backgroundColorHeader={"#00A81A"}
            headerTitle="SOURCING DETAILS"
          />
        </div>
      </div>
      <div className="column is-3">
        <div className="columns">
          <MainDataColumnComponent
            content={Successor(profile, mainData)}
            backgroundColorHeader={"#4C6900"}
            headerTitle="SUCCESSOR"
          />
        </div>
        <div className="columns">
          <MainDataColumnComponent
            content={ResponsibleReferences(
              mainData,
              profile,
              severityGroupsFiltered,
              onSeverityGroupChanged
            )}
            backgroundColorHeader={"#FF9D00"}
            headerTitle="Responsible"
          />
        </div>
        <div className="columns">
          <MainDataColumnComponent
            content={UsedInEngineType(
              product?.mainData?.partEngineTypes,
              "#FF9D00",
              onClick,
              profile
            )}
            backgroundColorHeader={"#FF9D00"}
            headerTitle="USED IN ENGINE TYPE"
          />
        </div>
        <div className="columns">
          <MainDataColumnComponent
            content={OtherPartsReferences(profile)}
            backgroundColorHeader={"#999999"}
            headerTitle="OTHER PART REFERENCES"
          />
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, {})(MainDataComponent);
